import { gql } from "@apollo/client";

export const GET_LIVE_STOCK = gql`
  query LiveStock($where: LiveStockWhereInputOne!) {
  liveStock(where:$where) {
      id
      amount
      amountAll
      live{
        id
      }
      stock {
        id
        name
        price
        amount
        image
        currency
        optionValues {
          id
          name
          value
        }
      }
      isPublished
      cfMessage
      createdAt
      updatedAt
      note
  }
}
`;

export const GET_SALE_PAGE_LIVE_STOCKS = gql`
  query salePageLiveStocks($where: LiveStockWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  salePageLiveStocks(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      amount
      amountAll
      stock{
        id
        name
        amount
        unit
        price
        image
        isDeleted
        currency
        optionValues {
          id
          name
          value
        }
      }
      isPublished
      cfMessage
      createdAt
      updatedAt
      note
    }
  }
}
`;
export const GET_LIVE_STOCKS = gql`
query LiveStocks($where: LiveStockWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  liveStocks(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      amount
      amountAll
      stock{
        id
        name
        amount
        unit
        price
        originPrice
        image
        isDeleted
        currency
        optionValues {
          id
          name
          value
        }
      }
      isPublished
      cfMessage
      createdAt
      updatedAt
      note
    }
  }
}
`;

export const GET_EXCHANGE_RATE = gql`
 query ExchangeRate($where: ExchangeRateWhereInput) {
  exchangeRate(where: $where) {
    kip
    baht
    usd
    id
    updatedAt
    createdAt
  }
}
`;